const footer = {
  nifName: "Norges idrettsforbund og",
  nifName2: "olympiske og paralympiske komité",
  support: "Kontakt NIF Digital Support",
  gdpr: "Om personvern"
};

export default footer;